module.exports = __webpack_public_path__ + "img/pay.b44c59a2.png";